<template>
    <div>
        <h2 class="ix-page-title-secondary mt-4">Évolution du taux de {{ marginType == 2 ? 'marque' : 'marge' }}</h2>
        <button class="d-none" @click="openDealProgressModal()" id="openProgress">progress</button>

        <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>
        <span v-if="!loading && chart.datasets.length == 0" class="ix-text-secondary ix-text-small">Graphique indisponible</span>

        <!-- Graphique -->
        <div v-if="chart.datasets.length > 0 && !loading">
            <svg style="width:0; height:0; position:absolute;" aria-hidden="true" focusable="false">
                <defs>
                    <linearGradient id="btcFill" x1="1" x2="1" y1="0" y2="1">
                        <stop offset="0%" stop-color="#077FD4"></stop>
                        <stop offset="100%" stop-color="#ffffff"></stop>
                    </linearGradient>
                </defs>
                </svg>

            <TrendChart
                :datasets="chart.datasets"
                :grid="chart.grid"
                :labels="chart.labels">
            </TrendChart>
        </div>

        <!-- Tableau -->

        <div v-if="arrayRemainings && arrayRemainings.length > 0 && !loading">
            <div class="ix-table-box mt-4">
                <table class="ix-table ix-table-sm">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th class="text-right">Reste à faire</th>
                            <th class="text-right">Marge dégagée</th>
                            <th class="text-center">
                                <span v-if="marginType == 1">Taux de marge</span>
                                <span v-if="marginType == 2">Taux de marque</span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(remaining, index) in allArrayRemainings" :key="index">
                            <td>{{ remaining.date_at | formatDate('DD MMMM YYYY') }}</td>
                            <td class="text-right">{{ currency(remaining.total) }}</td>
                            <td class="text-right">{{ currency(remaining.diff) }}</td>
                            <td class="text-center">
                                <span v-if="marginType == 1">{{ remaining.margin_rate }} %</span>
                                <span v-if="marginType == 2">{{ remaining.brand_rate }} %</span>
                            </td>
                            <td class="text-center">
                                <span v-if="canDelete">
                                    <a @click="destroyRemaining(remaining.id)" style="cursor: pointer"><i class="far fa-trash"></i></a>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

                <button class="ix-btn link mt-3" type="button" @click="displayAllHistory()" v-if="arrayRemainings.length > 5">
                    <span v-if="arrayRemainings.length > 5 && showFullHistory"><i class="far fa-chevron-up"></i> Réduire l'affichage</span>
                    <span v-if="arrayRemainings.length > 5 && !showFullHistory"><i class="far fa-chevron-down"></i> Afficher l'historique complet</span>
                </button>
            
        </div>
        

    </div>
</template>

<script>
    import TrendChart from "vue-trend-chart";
    import Swal from "sweetalert2";

    export default {
        name: 'deal-progress',
        props: ['suggestionsRoute', 'formRoute', 'setupRoute', 'destroyRoute' ,'marginType', 'canDelete', 'lots', 'notAllocated'],
        components: { TrendChart },
        data() {
            return {
                chart: {
                    datasets: [],
                    grid: {
                        verticalLines: true,
                        verticalLinesNumber: 1,
                        horizontalLines: true,
                    },
                    labels: {
                        xLabels: [],
                        yLabels: 4,
                        yLabelsTextFormatter: val => Math.round((val * 100) / 100) + "%"
                    }
                },

                form: {
                    date_at: this.moment().format('DD/MM/YYYY'),
                    minDate: null,
                    items: []
                },

                types: [
                    {label: "Main d'oeuvre", icon: "far fa-user", value: 1},
                    {label: "Achats", icon: "far fa-shopping-bag", value: 2},
                    {label: "Stocks", icon: "far fa-cube", value: 3},
                    {label: "Matériels", icon: "far fa-cog", value: 4},
                ],

                settings: {
                    hours_per_day: 7,
                    hourly_rate: 40
                },

                showError: false,
                loading: false,
                loadingForm: false,
                arrayRemainings: [],
                allArrayRemainings: [],
                showFullHistory: false,
            };
        },
        methods: {
            computeAttribute: function(item, attribute) {
                if (attribute == 'total') {
                    item.total = this.roundCurrency(item.quantity * item.amount * item.extra, 2)
                } else {
                    var quantity = 0;

                    if (item.amount != 0 && item.extra != 0) {
                        quantity = this.roundCurrency((parseFloat(item.total) / item.amount) / item.extra, 2)
                    }

                    item.quantity = quantity;
                }
            },
            filterItems: function(items, type) {
                return items.filter(item => item.type == type)
            },
            addDealRemainingItem: function(item, type) {
                var data = {
                    uniq: Math.random().toString(36).substr(2, 9),
                    type: type,
                    designation: item ? item.designation : '',
                    total: item ? item.total : 0,

                    quantity: item ? item.quantity : 1,
                    amount: item ? item.amount : (type == 1 ? this.settings.hourly_rate : 0),
                    extra: item ? item.extra : (type == 1 ? this.settings.hours_per_day : 1)
                }

                this.form.items.push(data)
                this.computeAttribute(data, 'total')

                setTimeout(() => {
                    if (item == null) {
                        $('#designation' + data.uniq).focus()
                    }
                    
                    this.initAutocomplete(data.uniq)
                }, 250)
            },
            destroyRemaining(id){ 
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;
                        fetch(this.destroyRoute, {
                            ...this.getHttpJsonRequestHeaders(),
                            ...{
                                method : "DELETE",
                                body :  JSON.stringify({remaining_id: id})
                            }
                        }).then((response) => {
                            if (response.status == 200) {
                                window.location.reload();
                            } else {
                                this.loading = false;
                            }
                        }).catch(error => {
                            this.loading = false;
                        })
                    }
                });
                
            },
            
            openDealProgressModal: function() {
                $('#dealProgressModal').modal()
            },
            displayAllHistory(){
                this.showFullHistory = !this.showFullHistory;
                let cloneArray = this.arrayRemainings;

                if(this.arrayRemainings.length > 5 && this.showFullHistory){
                    this.allArrayRemainings = this.arrayRemainings;
                } else {
                    this.arrayRemainings = cloneArray.slice();
                    this.allArrayRemainings = cloneArray.splice(0,5);
                }
            },
            getData: async function() {
                this.loading = true;
                fetch(this.setupRoute, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    if (data.datasets.length > 0 && data.labels.length > 0) {
                        data.datasets.forEach((d, i) => {
                            this.chart.datasets.push({
                                data: d,
                                smooth: false,
                                fill: true,
                                showPoints: false,
                                className: 'ix-curve-trending'
                            })
                        })
                        this.chart.labels.xLabels = data.labels
                    }

                    if(data.dealRemainings && data.dealRemainings.length > 0){
                        this.arrayRemainings = data.dealRemainings;

                        if(data.dealRemainings.length > 5 && !this.showFullHistory){
                            this.arrayRemainings = data.dealRemainings.slice();
                            this.allArrayRemainings = data.dealRemainings.splice(0, 5);
                        } else {
                            this.allArrayRemainings = this.arrayRemainings;
                        }
                    }

                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
        },
        mounted() {
            this.getData()
        }
    }
</script>

